export { default } from '../routes/landing-page/index';
